import * as React from "react";
const SvgFiRrLiveAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-live-alt_svg__a)">
      <path
        fill="#062147"
        d="M4.222 4.636a1 1 0 0 1 0-1.414c4.289-4.29 11.268-4.29 15.557 0a.999.999 0 1 1-1.414 1.414c-3.51-3.51-9.219-3.51-12.729 0a1 1 0 0 1-1.414 0M7.051 6.05a.999.999 0 1 0 1.414 1.414A4.97 4.97 0 0 1 12 6c1.335 0 2.591.52 3.535 1.464a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414A6.95 6.95 0 0 0 12 4c-1.87 0-3.627.728-4.949 2.05M24 14v6c0 2.206-1.794 4-4 4H4c-2.206 0-4-1.794-4-4v-6c0-2.206 1.794-4 4-4h16c2.206 0 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2zM5 19v-5a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m15-4a1 1 0 1 0 0-2h-1.5c-.827 0-1.5.673-1.5 1.5v5c0 .827.673 1.5 1.5 1.5H20a1 1 0 1 0 0-2h-1v-1h1a1 1 0 1 0 0-2h-1v-1zM8 13a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1m7.316.05a.996.996 0 0 0-1.265.633l-1.052 3.154-1.052-3.154a1 1 0 0 0-1.897.633l2 6a1 1 0 0 0 1.896 0l2-6a1 1 0 0 0-.632-1.265z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-live-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLiveAlt;
